import { jwtDecode } from "jwt-decode";

/**
 * Clears the local storage
 */
export const handleLogout = () => {
    localStorage.clear();
}


/**
 * Checks if a JWT token has expired
 * @param jwtToken - The JWT token to check
 * @param bufferSeconds - The number of seconds to buffer the expiration time
 * @returns True if the token has expired, false otherwise
 */
export function isTokenExpired(jwtToken: string, bufferSeconds = 5): boolean | null {
    const { exp } = jwtDecode(jwtToken);

    if (!exp) {
        console.error("Token does not contain 'exp' field.");
        return null;
    }

    // Current time in seconds
    const currentTime = Math.floor(Date.now() / 1000);

    const effectiveExpiration = exp - bufferSeconds;

    return currentTime >= effectiveExpiration;
}